import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { refreshToken, getToken, logout } from "./auth";
import { useNavigate } from 'react-router-dom';
import { withLocalStorageLock } from './localStorageHelper'
import API_ENDPOINTS from "../apiConfig";

export function useTokenManager(resetContext) {
  const navigate = useNavigate();

  useEffect(() => {
    const checkToken = async () => {
      const currentToken = getToken();
      if (!currentToken) return;

      try {
        const decoded = jwtDecode(currentToken);
        const expiryTime = decoded.iat + API_ENDPOINTS.refreshIntervalInSeconds;
        const remainingSec = expiryTime - (Date.now() / 1000);

        if (remainingSec <= 0) {
          await withLocalStorageLock("refresh_lock", async () => {
            const status = await refreshToken();
            if (status === 401) logout(navigate, resetContext);
          });
        } /*else {
          const timeString = new Date(remainingSec * 1000).toISOString().substring(11, 19);
          console.log(`Token is fresh. Next check in heartbeat. Time left: ${timeString}`);
        }*/
      } catch (err) {
        console.error("Token manager error:", err);
      }
    };

    // Trigger A: Run immediately on mount
    checkToken();

    // Trigger B: The 60s Heartbeat (covers active use & sleep/wake)
    const heartbeatId = setInterval(checkToken, API_ENDPOINTS.checkTimerSeconds * 1000);

    // Trigger C: Instant check when user returns to tab
    const handleVisibility = () => {
      if (document.visibilityState === "visible") checkToken();
    };
    document.addEventListener("visibilitychange", handleVisibility);

    // Clean up all triggers
    return () => {
      clearInterval(heartbeatId);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [navigate]); // navigate is stable, so this effect won't restart unnecessarily
}